export const Styles = ` 

  .ng-tooltip {
    display: inline-block;
    position: absolute;
    text-decoration: none;
    border: 1px solid #ccc;
    max-width: 275px;
    font-size: 14px;
    text-align: center;
    color: #000;
    box-shadow: 0 5px 10px rgba(0,0,0,.2);
    padding: 10px 12px;
    background: #fff;
    border-radius: 6px;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.5s;
}
.ng-tooltip-show {
  opacity: 1;
}
/* creates a triangle pseudo-element for each tooltip according it's position, 
one before that will make the border, other right over it that matches the tooltip background color */
.ng-tooltip-top:before {
  top: 100%;
  left: 50%;
  margin-left: -10px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-top-color: #ccc;
}

.ng-tooltip-top:after {
  top: 99%;
  left: 50%;
  margin-left: -10px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-top-color:#fff;
}
.ng-tooltip-bottom:before{
  bottom: 100%;
  left: 50%;
  content: '';
  margin-left: -10px;
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-bottom-color: #ccc;
}
.ng-tooltip-bottom:after {
  bottom: 98%;
  left: 50%;
  content: '';  
  margin-left: -10px;
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-bottom-color: #fff;
}
.ng-tooltip-left:before {
  top: 50%;
  left: 100%;
  margin-top: -10px;
  border-width: 6px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-left-color: #ccc;

}.ng-tooltip-left:after {
  top: 50%;
  left: 99%;
  margin-top: -10px;
  border-width: 6px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-left-color: #fff;
}
.ng-tooltip-right:before {
  top: 50%;
  right: 100%;
  margin-top: -10px;
  border-width: 6px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-right-color: #ccc;
}
.ng-tooltip-right:after {
  top: 50%;
  right: 99%;
  margin-top: -10px;
  border-width: 6px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-right-color: #fff;
}
`;
